export default "__VITE_ASSET__c72072fd__"